import { Actions, type SetActiveEventIdActionData } from "@client/actions";
import { setEventId } from "@client/lib/cookie";
import { type AppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { type Dispatch, type MiddlewareAPI } from "redux";

export default (api: MiddlewareAPI<Dispatch, AppState>) => (next) => (action: ReduxAction<any>) => {
  switch (action.type) {
    case Actions.SetActiveEventId: {
      const data = action.data as SetActiveEventIdActionData;
      setEventId(data.id);
      break;
    }
  }

  next(action);
};
